import type { FC } from 'react';
import React, { useState } from 'react';

import type { Picture } from 'app/components/commons/Uploader/Types';
import { Uploader } from 'app/components/commons/Uploader/Uploader';

import { HeaderWrapper } from '../HeaderWrapper/HeaderWrapper';

import './MediaForm.scss';

export const MediaForm: FC<Props> = ({
  handleSubmit,
  initialValue,
  isLoading = false,
}) => {
  const [pictures, setPictures] = useState<Picture[]>(initialValue);
  const add = (picture: Picture) =>
    setPictures((previousPictures) => [...previousPictures, picture]);
  const remove = (uid: string) =>
    setPictures((previousPictures) => {
      const index = previousPictures.findIndex(
        (pic) => uid === `${pic.pictureId}-${pic.id}`
      );

      if (index < 0) {
        return previousPictures;
      }

      return [
        ...previousPictures.slice(0, index),
        ...previousPictures.slice(index + 1),
      ];
    });
  const submit = () => handleSubmit(pictures);

  return (
    <HeaderWrapper
      nextDisabled={pictures.length < 20}
      handleNext={submit}
      isLoading={isLoading}
    >
      <div className="media-form-container">
        <div className="media-form">
          <div className="media-form-header">
            <div className="title">Photos</div>
            <div className="explanation">
              Upload all your photos here (hotel, spaces, rooms…), you’ll use
              them to complete the next steps
            </div>
          </div>
          <div className="media-form-body">
            <Uploader
              pictures={pictures}
              add={add}
              remove={remove}
              previewable
              showHint
            />
          </div>
        </div>
      </div>
    </HeaderWrapper>
  );
};

type Props = {
  handleSubmit: (pictures: Picture[]) => void;
  initialValue: Picture[];
  isLoading?: boolean;
};
